$('.js-sertificates-more').on('click', function () {
    $(this).closest('.js-sertificates').addClass('_opened');
});

// Swiper-слайдер для блока сертификатов
if ($('.js-main-sertificates').length) {
    $('.js-main-sertificates').each(function () {
        const mainSertSlider = new Swiper(this, {
            slidesPerView: 2,
            spaceBetween: 10,
            navigation: {
                nextEl: $(this).closest('.main-sertificates').find('.js-main-sertificates-next')[0],
                prevEl: $(this).closest('.main-sertificates').find('.js-main-sertificates-prev')[0],
            },
            breakpoints: {
                768: {
                    spaceBetween: 10,
                    slidesPerView: 4,
                },
                1140: {
                    slidesPerView: 6,
                    spaceBetween: 20,
                },
            },
        });
    });
}
